exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.masonry-grid[data-v-ba04a72a] {\n  width: 100%;\n  -moz-column-count: 3;\n       column-count: 3;\n  -moz-column-gap: 0;\n       column-gap: 0;\n}\n.masonry-content[data-v-ba04a72a] {\n  width: calc(100% - 10px);\n  padding: 5px;\n}\n.pagination-btn[data-v-ba04a72a]:focus {\n  outline: none;\n}\n.w-35[data-v-ba04a72a] {\n  width: 35%;\n}\n", ""]);

// exports
